<template>
  <div class="conmon-top">
    <el-row class="search-title common-table-top" style="margin-top: 20px">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <a :href="openUrl" type="primary" size="large" class="authorization-btn" style="float: right;">授权小程序第三方</a>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table class="table" v-loading="loading" :data="tableData">
        <el-table-column prop="nick_name" label="小程序名称">
        </el-table-column>
        <el-table-column label="LOGO">
          <template slot-scope="scope">
            <img :src="scope.row.head_img" style="height: 100px; width: 100px;">
          </template>
        </el-table-column>
        <el-table-column prop="original_id" label="原始ID">
        </el-table-column>
        <el-table-column width="135" label="授权时间">
          <template slot-scope="scope">
            {{scope.row.create_time}}
          </template>
        </el-table-column>
        <el-table-column label="体验二维码">
          <template slot-scope="scope">
            <div v-if="scope.row.demo_qrcode_url">
              <img :src="scope.row.demo_qrcode_url" style="height: 100px; width: 100px;"
                @click="getQrCode(scope.row.id, 0)">
            </div>
            <div v-else>
              <div class="op-link" @click="getQrCode(scope.row.id, 0)">
                获取
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label=" 状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0" class="op-link" @click="codeCommit(scope.row.id, 0)">
              待提交代码
            </div>
            <div v-if="scope.row.status === 1" class="op-link" @click="submitAudit(scope.row.id, 0)">
              待提交审核
            </div>
            <div v-if="scope.row.status === 2" class="op-link" @click="auditStatus(scope.row.id, 0)">
              审核中
            </div>
            <div v-if="scope.row.status === 3" class="op-link" @click="release(scope.row.id, 0)">
              待发布
            </div>
            <div v-if="scope.row.status === 4">
              已发布({{scope.row.version}})
            </div>
          </template>
        </el-table-column>
        <el-table-column width="150" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0" class="op-link" @click="codeCommit(scope.row.id, 0)">
              上传代码
            </div>
            <div v-if="scope.row.status !== 2" class="op-link" @click="showSwitchingVersion(scope.row.id)">
              <!--升级到{{scope.row.upgrade_version}}-->
              切换代码版本
            </div>
            <div v-if="scope.row.status === 1" class="op-link" @click="submitAudit(scope.row.id, 0)">
              提交审核
            </div>
            <div v-if="scope.row.status === 2" class="op-link" @click="auditStatus(scope.row.id, 0)">
              查询状态
            </div>
            <div v-if="scope.row.status === 3" class="op-link" @click="release(scope.row.id, 0)">
              发布
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--切换版本窗口-->
      <el-dialog class="cellDialog base-dialog" title="切换代码版本" :visible.sync="switchingVersion" width="600px">
        <el-form ref="versionForm" :model="versionForm" style="text-align: left;">
          <el-form-item label="选择版本：" prop="type">
            <el-select v-model="versionForm.itemVersion" placeholder="请选择版本">
              <el-option v-for="item in versionOptions" :key="item.template_id+'_'+item.user_version"
                :label="'模板ID:'+item.template_id+' 版本：'+item.user_version"
                :value="item.template_id+'_'+item.user_version">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="switchingVersion = false" style="margin-left: 20px">取 消
          </el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitVersionForm()">确
            定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import {
  appletList,
  appletTemplateList,
  startOrStopPublic,
  setDefaultPublicNum,
  appletCodeCommit,
  appletAction,
  appletSubmitAudit,
  appletAuditStatus,
  appletRelease
} from '@/api/customer.js'
import { API_HOST } from '../../api/local'

export default {
  name: 'appletList',
  data () {
    return {
      loading: true,
      tableData: [],
      originalId: '',
      isDisabled: false,
      defaultDisabled: false,
      switchingVersion: false,
      appletId: 0,
      versionOptions: [],
      versionForm: {
        itemVersion: ''
      },
      template_version: ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 显示版本列表
    showSwitchingVersion (id) {
      appletTemplateList(id).then((res) => {
        if (res.data.code === 0) {
          this.versionOptions = res.data.result
          this.switchingVersion = true
          this.appletId = id
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    submitVersionForm () {
      this.template_version = this.versionForm.itemVersion.split('_')
      console.log(this.template_version)
      if (this.template_version.length === 2) {
        appletCodeCommit(this.appletId, this.template_version[0], this.template_version[1]).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.switchingVersion = false
          this.getData()
        })
      } else {
        _g.toastMsg('error', '请选择版本')
      }
    },
    codeCommit (id) {
      this.$confirm('确定要上传代码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        appletCodeCommit(id, '', '').then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    getQrCode (id) {
      appletAction(id, 'getQrCode').then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    getCategory (id) {
      appletAction(id, 'getCategory').then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    getPage (id) {
      appletAction(id, 'getPage').then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    submitAudit (id) {
      this.$confirm('确定要提交审核', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        appletSubmitAudit(id).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    auditStatus (id) {
      appletAuditStatus(id).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    release (id) {
      this.$confirm('确定要发布', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        appletRelease(id).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    startOrStopPublicAction (id, status) {
      let strMsg = ''
      if (status === 0) {
        strMsg = '是否启用该小程序'
      } else {
        strMsg = '是否禁用该小程序'
      }
      this.$confirm(strMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeWechatApi(id, status)
      }).catch((error) => {
        console.log(error)
      })
    },
    setDefaultPublicNumAction (item) {
      setDefaultPublicNum(item.id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    getData () {
      this.loading = true
      appletList().then((res) => {
        if (res.data.code === 0) {
          this.originalId = res.data.data.originalId
          for (let item of res.data.data.list) {
            if (item.original_id === this.originalId) {
              item.statuss = 1
            } else {
              item.statuss = 0
            }
            if (item.version != res.data.data.version) {
              item.upgrade_version = res.data.data.version
            } else {
              item.upgrade_version = ''
            }
          }
          this.tableData = res.data.data.list
          console.log(this.tableData)
          if (this.tableData.length === 1) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    changeWechatApi (id, status) {
      startOrStopPublic(id, status).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '操作成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  computed: {
    openUrl () {
      let userInfo = Lockr.get('userInfo')
      return API_HOST + 'yunzhong/ez_open_platform/getRequestCodeURL?uid=' + userInfo.id + '&referer=' + window.location.href
    }
  },
  created () { }
}
</script>
<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}

.green {
  color: green;
}

.red {
  color: red;
}

.authorization-btn {
  padding: 2px 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  display: block;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 8px;
  margin-right: 13px;
  cursor: pointer;
}

.table-title {
  text-align: left;
}

.dialog-content {
  height: 200px;
}

.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}

.content-one p {
  text-align: left;
}

.set-default {
  color: #1980ff;
  cursor: pointer;
  font-size: 14px;
}

.is-default {
  font-size: 14px;
  cursor: not-allowed;
}
</style>